<!--@let isCoverImageUniformControlValue = isCoverImageUniformControl();-->
@let i18nPrefixValue = i18nPrefix();
<ng-container>
  <div class="flex w-full gap-8">
    <!--    <mat-slide-toggle name="is-cover-image-unitform" [formControl]="isCoverImageUniformControlValue"-->
    <!--      >{{ t('UNIFIED_COVER_IMAGE') }}-->
    <!--    </mat-slide-toggle>-->
  </div>
  <div class="text-bold mb-4">{{ 'PAGES.COMMON.DETAILS.FORM.COVER_IMAGE' | transloco }}</div>
  @let resizeModeControlValue = resizeModeControl();
  @if (!(resizeModeControlValue | isNil) && !(resizeModeControlValue.value | isNil)) {
    <pct-form-string-slide-toggle
      label="PAGES.COMMON.DETAILS.FORM.RESIZE_MODE"
      nameAttribute="resize-mode"
      [defaultValue]="cover"
      [falseValue]="contain"
      [formControl]="resizeModeControlValue"
      [matTooltip]="'COMMON.RESIZE_MODE_TOOLTIP' | transloco"
      [trueValue]="cover"
    />
  }

  <mat-divider class="!my-4" style="margin-left: -1rem; margin-right: -1rem" />
  <div>
    <cappus-cover-image
      [fileUploadService]="fileUploadService()"
      [formControl]="coverImageControl()"
      [i18nPrefix]="i18nPrefixValue"
      [isSubtitleRequired]="isSubtitleRequired()"
      [parentFormSubmitted]="submitted()"
      [selectedLanguage]="selectedLanguage()"
      [startedLanguages]="startedLanguages()"
    />
  </div>
</ng-container>
